<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  [nzWidth]="684"
  [nzTitle]="header()"
  (nzOnCancel)="onClose()"
  [nzCloseIcon]="closeIcon"
  [nzContent]="modalContent"
  [nzMaskClosable]="false"
>
  <ng-template #closeIcon>
    <img alt="closeTab" src="assets/icons/exit_new.svg" />
  </ng-template>

  <ng-template #modalContent>
    <div class="card-layer" [class.mobile]="isMobile()">
      <div class="buttonwrapper">
        @for (item of instructions(); track item?.id ?? item) {
          <div>
            <nz-radio-group nzName="radiogroup" [ngModel]="radioValue()">
              <button
                class="rotatingEqu-item"
                [class.active]="radioValue() === item.id"
                (click)="onRadioChange(item.id)"
              >
                <img
                  nz-image
                  nzDisablePreview
                  class="rotatingEqu-item-icon"
                  [nzSrc]="item.image ?? ''"
                  [class.mobile]="isMobile()"
                />
                <label
                  nz-radio
                  [nzValue]="item.id"
                  role="button"
                  tabindex="0"
                  (click)="onRadioChange(item.id)"
                ></label>
                <span class="icon-text body-bold">
                  {{ i18n.parse(item.title) }}
                </span>
              </button>
            </nz-radio-group>
          </div>
        }
      </div>

      <div class="rotatingEqu-button">
        <app-nav-button
          [primary]="true"
          [disabled]="formInvalid()"
          (clickEvent)="onSave()"
          [svgIcon]="'icons:save'"
        >
          {{ i18n.langString("save_image") }}
        </app-nav-button>
      </div>
    </div>
  </ng-template>
</nz-modal>
